/** Theme background + palette for canvas preview (from rendered_timeline.presentation.theme). */

function parseRgb(val, fallback) {
  if (Array.isArray(val) && val.length >= 3) {
    return [Number(val[0]), Number(val[1]), Number(val[2])];
  }
  if (typeof val === 'string' && val.includes(',')) {
    const parts = val.split(',').map((n) => Number(n.trim()));
    if (parts.length >= 3 && parts.every((n) => Number.isFinite(n))) return parts.slice(0, 3);
  }
  return fallback;
}

function cssRgb(rgb) {
  const [r, g, b] = rgb;
  return `rgb(${r}, ${g}, ${b})`;
}

export function themePalette(renderedTimeline) {
  const theme = renderedTimeline?.presentation?.theme || {};
  return {
    bg_top: parseRgb(theme.bg_top, [30, 41, 59]),
    bg_bottom: parseRgb(theme.bg_bottom, [15, 23, 42]),
    text: parseRgb(theme.text, [241, 245, 249]),
    codeBg: parseRgb(theme.code_bg, [30, 41, 59]),
    codeBorder: parseRgb(theme.code_border, [71, 85, 105]),
    accent: parseRgb(theme.accent, [52, 211, 153]),
    console: parseRgb(theme.console, [134, 239, 172]),
    keyword: parseRgb(theme.keyword, [250, 204, 21]),
    highlight: parseRgb(theme.highlight, [234, 179, 8]),
  };
}

/** Draw gradient background; returns CSS color strings for drawLearningPreviewFrame. */
export function drawThemeBackground(ctx, renderedTimeline, w, h) {
  const raw = themePalette(renderedTimeline);
  const g = ctx.createLinearGradient(0, 0, 0, h);
  g.addColorStop(0, cssRgb(raw.bg_top));
  g.addColorStop(1, cssRgb(raw.bg_bottom));
  ctx.fillStyle = g;
  ctx.fillRect(0, 0, w, h);
  return {
    bg_top: cssRgb(raw.bg_top),
    bg_bottom: cssRgb(raw.bg_bottom),
    text: cssRgb(raw.text),
    codeBg: cssRgb(raw.codeBg),
    codeBorder: cssRgb(raw.codeBorder),
    accent: cssRgb(raw.accent),
    console: cssRgb(raw.console),
    keyword: cssRgb(raw.keyword),
    highlight: cssRgb(raw.highlight),
  };
}
